const SDK_URL = 'https://cfe.m.jd.com/privatedomain/jdlbs/2.1.0/jdlbs.min.js';
/**
 * 加载LBS定位所需sdk文件
 * @returns
 */

const checkLbsStatus = () => {
    return new Promise((resolve, reject) => {
      if (typeof jdlbs.hasLocationPermissionWithScene === 'undefined') reject()
      jdlbs.hasLocationPermissionWithScene({
        appid: '5bb5fc8a387c427d4e904810c8acf8fd',
        sceneId: 'locService',
        success({ status, param, data, msg }) {
          resolve(data)
        },
        fail({ status, param, data, msg }) {
          reject(data)
        }
      })
    })
  }
  
  const requestLocationPermission = () => {
    return new Promise((resolve, reject) => {
      if (typeof jdlbs.requestLocationPermissionWithScene === 'undefined') reject()
      jdlbs.requestLocationPermissionWithScene({
        appid: '5bb5fc8a387c427d4e904810c8acf8fd',
              sceneId: 'locService',
              sceneContent: '允许京东使用你的位置', //新增，必传。场景描述
        success({ status, param, data, msg }) {
          resolve(data)
        },
        fail({ status, param, data, msg }) {
          reject(data)
        }
      })
    })
  }
  
 const getLatLng = (e) => {
    if (typeof jdlbs.getLatLng === 'undefined') e()
    jdlbs.getLatLng({
      appid: '5bb5fc8a387c427d4e904810c8acf8fd',
      sceneId: 'locService',
      success({ status, param, data, msg }) {
        if (status + '' === '0') {
          e(data)
        } else {
          e()
        }
      },
      fail({ status, param, data, msg }) {
        e()
      }
    })
  }
  
  const getPhoneBasicInfo = (e) => {
    checkLbsStatus().then(res => {
      const { code, result } = res || {}
      if (code + '' === '0' && result) {
        getLatLng(e)
      } else {
        requestLocationPermission().then(res => {
          const { code, result } = res || {}
          if (code + '' === '0' && result) {
            getLatLng(e)
          } else {
            e()
          }
        }).catch(() => {
          e()
        })
      }
    }).catch(() => {
      requestLocationPermission().then(res => {
        const { code, result } = res || {}
        if (code + '' === '0' && result) {
          getLatLng(e)
        } else {
          e()
        }
      }).catch(() => {
        getLatLng(e)
      })
    })
  }

  // h5端获取定位信息
	const getH5Position = () => {
    return new Promise(async(resolve, reject) => {
      // 浏览器环境获取经纬度
      if (navigator && navigator.geolocation) {
        try {
          navigator.geolocation.getCurrentPosition(function (position) {
            var coords = (position || {}).coords
            resolve({lat: coords.latitude, lng: coords.longitude})
          }, function (error) {
            reject()
          }, {
            enableHighAcuracy: false,
            timeout: 5000,
            maximumAge: 3000
          })
        } catch (e) {
          reject()
        }
      } else {
        reject()
      }
    })
	}

// 原生端获取定位信息
const  getNativeInfo = () => {
    return new Promise((resolve, reject) => {
        getPhoneBasicInfo(res => {
            setTimeout(() => {
                if (res) {
                        try {
                        res = typeof res === 'string' ? JSON.parse(res) : res
                        let {
                            lat,
                            lng,
                            srclat,
                            srclng
                        } = res.data || res || {}
                        var rObj = {}
                        const resLat = lat || srclat
                        const resLng = lng || srclng
                        if (resLat && resLng && resLat != 0 && resLng != 0) {
                            rObj.lat = resLat
                            rObj.lng = resLng
                            resolve(rObj);
                        } 
                    } catch (err) {
                      reject()
                    }
                } else {
                  reject()
                }
            }, 0)
        })
    }); 
}


const loadSdkScript = () => {
    return new Promise((resolve) => {
        if (window.jdlbs) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.crossorigin = 'anonymous';
        script.onload = function() {
            resolve();
        };
        script.onerror = function() {
            resolve();
        };
        script.src = SDK_URL;
        document.body.appendChild(script);
    });
};


 
/**
 * 获取lbs
 */
const getLatLngForWeb = (businessId) => {
  return new Promise(async(resolve, reject) => {
      if (navigator.userAgent.toLowerCase().indexOf('jdapp') != -1) { // 判断app
          await loadSdkScript().catch(err => {
              console.log('加载js失败2');
              reject(err);
          });
          const loadSuccess = window.jdlbs ? true : false
          if (loadSuccess) {
            getNativeInfo().then(resLatLng => { 
              resolve(resLatLng)
            }).catch(() => {reject()})
          } else {
            reject(new Error('加载js失败'));
          }
      } else {
        getH5Position().then(resLatLng => { 
          resolve(resLatLng)
        }).catch(() => {reject()})
      }
    }); 
};

export {
    getLatLngForWeb,
    getPhoneBasicInfo
};
